import type { PriceRange } from './types';

export const PRESET_PRICE_RANGES: PriceRange[] = [
  { min: 0, max: 10 },
  { min: 10, max: 20 },
  { min: 20, max: 50 },
  { min: 50, max: 100 },
  { min: 100, max: null },
];
